<script>
  import './style.scss';
  import template from './template.html';
  import { FileStatus, FileOrigin } from 'filepond';
  import vueFilePond from "vue-filepond";
  import filesize from 'filesize';
  import { fpServer } from './fp-server';
  import {
    InformationOutlineIcon,
    TrashCanOutlineIcon,
    FileDocumentOutlineIcon,
    RefreshIcon,
  } from '../../icons.js';
  import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
  //import FilePondPluginImagePreview from "filepond-plugin-image-preview";
  import FilePondPluginFileEncode from 'filepond-plugin-file-encode';
  import filePondLabelTemp from './filepond-label-template.html';
  import { filePondDeleteMethod } from './filepond-delete-method';
  import {mapState, mapMutations, mapActions, mapGetters} from 'vuex';
  import ConnectorTiles from "./ConnectorTiles.vue";
  import { fileTypes } from './file-types';

  // Create component
  const FilePond = vueFilePond(
    FilePondPluginFileValidateType,
    //FilePondPluginImagePreview,
    FilePondPluginFileEncode,
  );

  export default {
    template,

    props: {

      orderId: {
        type: [String, Number],
        default: 0
      },

      order: {
        type: Object,
        default() {
            return {}
        }
      },

      csrfToken: {
        type: [String, Number],
        default: ''
      },

      uploadedFilesPath: {
        type: String,
        required: true
      },

      uploadFilePath: {
        type: String,
        default: '/orders/upload'
      },

      fileType: {
        type: String,
        default: 'source'
      },

      availableFileTypes: {
        type: Array,
        default: Object.keys(fileTypes)
      },

      useDefaultServerProcess: {
        type: Boolean,
        default: false
      }
    },

    beforeMount () {
      //get uploaded files that may have been stored in user session
      this.getUploadedFiles().then(this.mapUploadedFilesToFilepond);
    },

    mounted () {

      //watch for any new files uploaded by the connectors
      EventBus.$on('file-uploaded', () => {
        //add uploaded files to filepond
        this.getUploadedFiles().then(this.mapUploadedFilesToFilepond);
      });

      // console.log('adding event')
      //watch for new filepond files
      EventBus.$on('update-pond-files', this.updatePondFiles);

      EventBus.$on('filepond-progress', (progress, ele) => {
        // console.log('progress', progress);
        // console.log('progress ele', ele);
      });

      //set defualt file type
      this.setUploadFileType(this.fileType);
    },

    computed: {

      ...mapState({
        coStore: state => state.CreateOrderStore,
        activeConnectors: state => state.ConnectorTilesStore.activeConnectors,
      }),

      ...mapState({
        uploadFileType: state => state.CreateOrderStore.orderDetails.uploadFileType
      }),

      storeFilesUploading: {
        get () {
          return this.coStore.uploadFiles.filesUploading;
        },

        set (value) {
          this.setFilesUploading(value);
        }
      },

      files: {

        get () {
          return this.coStore.uploadFiles.files;
        },

        set (value) {
          this.setUploadFiles(value)
        }
      },

      //checks if we are updating an existing(new) order
      isNewOrder () {
        return !_.isEmpty(this.orderId);
      },
    },

    methods: {

      ...mapMutations('CreateOrderStore', [
        'setUploadFileType',
        'setUploadFiles',
        'setFilesUploading',
      ]),

      /**
       * Change the upload file type.  Source or references
       *
       * @param string $type
       */
      changeUploadFileType (type) {
        return this.setUploadFileType(type);
      },

      /**
       * Load previous order files into filepond
       *
       *
       */
      getUploadedFiles () {
        return axios
          .get(this.uploadedFilesPath)
          .then(result => result.data.files);
      },

      /**
       * This is a developer method for file pond
       *
       * @return array
       */
      pond () {
        let pond = this.$refs.pond;
        let files = JSON.stringify(pond.getFiles());

        console.log('vuex files', this.files);

        console.log('pond', pond)
        console.log('files', pond.getFiles())

        pond.getFiles().forEach(file => {
          console.log('filestatus', file.status);
        });

        return this.$refs.pond;
      },

      /**
       * Update with new filepond files
       *
       * @return null
       */
      updatePondFiles () {
        //add filepond files
        let pond = this.$refs.pond;
        this.pondFiles = pond.getFiles();

        //console.log('updating pond files', this.pondFiles.length)
        this.pondFiles.forEach(file => {
            if (file.filename.startsWith(this.FILE_FEEDBACK_PREFIX)) {
                pond.removeFile(file.id);
            }
        });

        this.pondFiles = pond.getFiles();

        //set progress bar
        this.pondFiles.forEach(file => {
          if (this.progressBars[file.id]) return;

          //console.log(file.status)

          this.progressBars[file.id] = {
            progress: 1,
            color: '#369763',
            error: false,
            message: '',
          };
        });
      },

      /**
       * Get current uploading file information
       *
       * @return Object
       */
      uploadingFiles () {
        let {pond} = this.$refs;
        let files = pond.getFiles();
        let totalFiles = files.length;
        let uploadedCount = 0;
        let perct = 0;

        for (let i = 0; i < totalFiles; i++) {
          let file = files[i];
          //has file finished uploading?
          //status is 5 from filepond when file is fully processed
          if (file.status == FileStatus.PROCESSING_COMPLETE) {
            uploadedCount = uploadedCount + 1;
          }
        }
        perct = Math.floor((100 * uploadedCount) / totalFiles) || 0;
        return { uploadedCount, totalFiles, perct};
      },

      /**
       * Check if files are currently uploading
       *
       * @return boolean
       */
      filesUploading () {
        let isUploading = false;

        if (this.filepondReady) {
          let { pond } = this.$refs;
          let files = pond.getFiles();

          for (let i = 0; i < files.length; i++) {
            if (files[i].status < 5) {
              isUploading = true;
              break;
            }
          }
        }

        return isUploading;
      },

      /**
       * Filepond init method
       *
       */
      handleFilePondInit () {
       console.log("FilePond has initialized");

       this.filepondReady = true;
       // FilePond instance methods are available on `this.$refs.pond`
      },

      /**
       * Check if file is currently uploading
       *
       * @param Object file
       * @return boolean
       */
      fileIsUploading (file) {
        return this.progressBars[file.id].progress < 100 && file.status !== FileStatus.PROCESSING_COMPLETE;
      },

      /**
       * Add uploaded files to filepond files list
       *
       */
       mapUploadedFilesToFilepond  (files) {
         //let app know that we potentially have new filepond files
         EventBus.$emit('update-pond-files');

         this.filepondFiles = files.map(file => {

           //@TODO - normalize file type naming and remove this
           let type = file.file_type;
           if (type == 'reviewed') type = 'feedback';

           return {
             // the server file reference
             source: file.id,

             // set type to local to indicate an already uploaded file
             options: {
               type: 'local',

               // mock file information
               file: {
                 name: file.original_filename,
                 size: file.size,
                 type: file.mime_type,
               },

               metadata: {
                  fileUploadType: type,
                },
             }
           }
         });

         this.$nextTick(() => {
           this.files = this.$refs.pond.getFiles();
         })

         return this.filepondFiles;
       },

      /**
       * Event when user removes Filepond file
       *
       * @param Object error
       * @param Object file
       */
      fpFileRemoved (error, file) {
        EventBus.$emit('update-pond-files');

        this.$nextTick(() => {
          this.storeFilesUploading = this.filesUploading();
        });
      },

      /**
       * We've made progress uploading a file
       *
       * @param Object file
       * @param Integer progress
       */
      fpProgressUpdate (file, progress) {
        // console.log('updating', file);
        // console.log('progress', progress)
        // console.log('some', some)
        this.addProgress(file, progress)
      },

      /**
       * Aborted a file upload process
       *
       */
      fpProcessAbort (file) {
        if (file.status == FileStatus.IDLE) {
          this.deletePondFile(file);
        }

        this.$nextTick(() => {
          this.storeFilesUploading = this.filesUploading();
        });
      },

      /**
       * All files have finished processing
       *
       */
      fpProcessComplete (files) {
        console.log('upload process has completed')
        this.storeFilesUploading = false;
        this.$emit('file-uploads-complete', files);

        //make sure the view is updated
        this.$forceUpdate();
      },

      /**
       * A file has been processed
       *
       * @param Object error
       * @param Object file
       */
      fpProcessedFile (error, file) {
        let index = this.fileRenameQueue.findIndex(r => r.lastModified == file.file.lastModified);

        if (index > -1) {
          let renamedFile = this.fileRenameQueue.splice(index, 1)[0];

          this.$nextTick(() => {
            let updateFile = this.$refs.pond.getFile(file.id);

            this.setFileRename(updateFile, renamedFile.renamedFilename);
            this.$forceUpdate();
          });
        }
      },

      /**
       * Event when user creates a new file
       *
       * @param Object file
       */
      fpCreatedFile (file) {
        let fileName = file.file.name;
        if(fileName.startsWith(this.FILE_FEEDBACK_PREFIX)) {
          this.fpWarningMsg = `Invalid file name ${fileName}. File names cannot contain ${this.FILE_FEEDBACK_PREFIX}.`;
          setTimeout(() => this.fpWarningMsg = '', 3000);
          if (file.status == FileStatus.PROCESSING) {
            file.abortProcessing();
            this.$refs.pond.removeFile(file);
          }
          return;
        }

        //check if any files are uploading
        if (this.filesUploading()) {
          this.$emit('file-uploading',  file);
          this.storeFilesUploading = true;
          console.log('file uploading')
        }

        EventBus.$emit('update-pond-files');
      },

      /**
       * Handle filepond error
       *
       * @param Object error
       * @param Object file
       */
      fpError (error, file) {
        console.log('filepond error', error);
        let progressBar = this.progressBars[file.id];

        if (error.code == 204) {
          console.log("skipping error, operation cancelled by user", file);
          file.abortProcessing();
        } else {
          this.$set(this.progressBars, file.id, Object.assign(progressBar, {
            color: '#e74c3c',
            progress: 99,
            error: true,
            message: 'Error during upload. Click the retry icon to try again.'
          }))
        }

        this.$forceUpdate();
        // console.log('file', file);
        // console.log('error', error);
      },

      /**
       * Handle filepond warning
       *
       */
      fpWarning (warning, files) {
        if (warning.body == 'Max files') {
          this.fpWarningMsg = 'You can upload a maximum of 100 files';
        }

        setTimeout(() => this.fpWarningMsg = '', 3000)
      },

      /**
       * Event handler for file uploads
       *
       * @param Object formData
       * @return Object
       */
      onFileUploadData (formData) {
        formData.append('orderfiletype', this.uploadFileType === 'source' ? 'sf' : 'rf');
        formData.append('orderid', 0);
        //formData.append('files', this.$refs.pond.getFiles())

        return formData;
      },

      /**
       * delete/remove a filepond file
       *
       * @param Object file
       */
      deletePondFile (file) {
        //if the file is still processing
        //abort the process

        if (file.status == FileStatus.PROCESSING) {
          file.abortProcessing();

          //sometimes the file may have finished uploading but all of
          //filepond's processing hasn't completed yet
          //This will catch that edge case and delete the aborted file that does have a server id
          return this.$nextTick(() => {
            if (file.serverId) {
              filePondDeleteMethod(file.serverId, _.noop, (err) => console.error(err));
            }
          });
        }
        //EventBus.$emit('update-pond-files');

        this.$refs.pond.removeFile(file);
        //this is a file created during this browser session
        //@TODO - Currently there's an error where filepond doesn't
        //call the revert method on newly created files
        //but don't call if file status is 2, which means file was aborted
        //there is no fileid for aborted files
        //@TODO - we should return a temp file id for cleanup of aborted files
        if (
          (file.origin == FileOrigin.INPUT || file.origin == FileOrigin.LOCAL)
          && file.status !== FileStatus.IDLE
        ) {
          this.$nextTick(() => {
            filePondDeleteMethod(file.serverId, _.noop, (err) => console.error(err));
          })
        }
      },

      /**
       * remove all pond files
       *
       */
      removeAllPondFiles () {
         //this.$refs.pond.removeFiles({ revert: false });
         let { pond } = this.$refs;

         let files = pond.getFiles();

         files.forEach(file => {
           this.deletePondFile(file);
         });
      },

      /**
       * retry uploading a filepond file
       *
       * @param Object file
       */
      retryPondFile (file) {
        //console.log('retrying')
        this.$refs.pond.processFile(file);
      },

      /**
       * Update file progress
       *
       * @param Object file
       * @param Integer progress
       */
      progressUpdate (file, progress) {
        // console.log('updating', file);
        // console.log('progress', progress)
        // console.log('some', some)
        this.addProgress(file, progress)
      },

      /**
       * add fileuploadtype metadata to file
       *
       * @param Object error
       * @param Object file
       */
      addMetadata (error, file) {
        if (error || file.status == 5) return;

        //set the file metadata
        file.setMetadata('fileUploadType', this.uploadFileType)
      },

      /**
       * Update file progress
       *
       * @param Object file
       * @param Integer progress
       */
      progressUpdate (file, progress) {
        // console.log('updating', file);
        // console.log('progress', progress)
        // console.log('some', some)
        this.addProgress(file, progress)
      },

      /**
       * Add progress to file progress
       *
       * @param Object file
       * @param Integer progress
       */
      addProgress (file, progress) {
        //update files progress
        //@TODO - cleanup after?
        this.$set(this.progressBars, file.id, {
          progress: Math.floor(progress * 100),
          color: '#369763',
          error: false,
        });

        //@TODO - should we have to do this
        //event is coming from external componenet
        this.$forceUpdate();
      },

      /**
       * Get the file upload type ( source or reference )
       *
       * @param Object file
       * @return String
       */
      getFileUploadType (file) {
        let type = file.getMetadata('fileUploadType');

        if (!type) return null;

        return fileTypes[type];
      },

      /**
       * convert filesize to readable format
       *
       * @param Integer size
       *
       * @return string
       */
      getFilesize (size) {
        return filesize(size);
      },

      /**
       * set file rename
       *
       * @param Object file
       * @param String rename
       */
      setFileRename (file, rename) {
        file = Object.assign(file, {renamedFilename: rename});
      },

      /**
       * Get file rename
       *
       * @param Object file
       * @return String|Null
       */
      getFileRename (file) {
        return file.renamedFilename;
      },

      /**
       * Add to queue of files we need to rename
       *
       * @param Object file
       * @param Object metadata ( including file rename )
       */
      addToFileRenameQueue (file, metadata) {
        let { lastModified } = file;
        this.fileRenameQueue.push(Object.assign({}, { lastModified }, metadata));
      },
    },

    data () {

      let selected = Object.assign({}, this.selected);

      let data = {
        filePondLabel: filePondLabelTemp,
        fpWarningMsg: '',
        pondFiles: [],
        filepondFiles: [],
        fileRenameQueue: [],
        progressBars: {},
        filepondReady: false,
        fpServer: {},
        FILE_FEEDBACK_PREFIX: 'client_feedback'
      }

      //add custom server file processing methods
      if (!this.useDefaultServerProcess) {

        data = Object.assign({}, data, {

          /**
           * Filepond server process method
           */
          fpServer: fpServer.call(this)
        })
      }

      return data;
    },

    filters: {
      capitalize: function (value) {
        if (!value) return ''
        value = value.toString()
        return value.charAt(0).toUpperCase() + value.slice(1)
      }
    },

    components: {
      FilePond,
      InformationOutlineIcon,
      TrashCanOutlineIcon,
      FileDocumentOutlineIcon,
      RefreshIcon,
      ConnectorTiles,
    },

    directives: {},

    created () {
      //this.selectedItem = this.items[0];
    }
  }
</script>
